import { render, staticRenderFns } from "./InMobiIcon.vue?vue&type=template&id=af4c6886&"
import script from "./InMobiIcon.vue?vue&type=script&lang=js&"
export * from "./InMobiIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports